import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import _ from 'lodash';

import GET_TASKS_FOR_DATE from 'graph/queries/exercises';
import { Carousel, CarouselArrow, CarouselDots } from '@keethealth/keet-ui';
import Panel from 'common/Panel';
import { getQuantities } from 'utils/content';
import history from 'utils/history';
import TaskDetail from './TaskDetail';
import '../task.css';

export class Task extends Component {
  static defaultProps = {
    tasks: [],
  }

  static propTypes = {
    tasks: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      completed: PropTypes.bool,

      videoUrl: PropTypes.string,
      imageUrl: PropTypes.string,
      equipment: PropTypes.string,
      description: PropTypes.string,

      quantityType: PropTypes.oneOf(['REPS', 'DURATION']),
      times: PropTypes.number,
      sets: PropTypes.number,
      reps: PropTypes.number,
      durationType: PropTypes.oneOf(['SECONDS', 'MINUTES', 'HOURS']),
      duration: PropTypes.number,
    })),
    match: PropTypes.object.isRequired,
  }

  state = {
    currentIndex: 0,
  }

  componentWillReceiveProps(nextProps) {
    const {
      tasks,
      match: { params: { taskId } },
    } = nextProps;
    if (tasks.length > 0) {
      const taskIndex = _.findIndex(tasks, { id: taskId });
      this.setState({
        currentIndex: taskIndex,
      });
    }
  }

  handleChangeSlide = newIndex => () => {
    const {
      tasks,
      match: { params: { selectedDate } },
    } = this.props;
    const newTaskId = tasks[newIndex].id;
    history.push(`/task/${selectedDate}/${newTaskId}`);
  }

  renderTasks = () => {
    const {
      tasks,
      match: { params: { taskId } },
    } = this.props;
    const { currentIndex } = this.state;
    if (taskId && tasks.length > 0) {
      return (
        <Carousel
          className="w-100 flex-auto overflow-auto"
          controlled
          currentIndex={currentIndex}
        >
          {tasks.map(task => (
            <TaskDetail
              key={task.id}
              id={task.id}
              completed={task.completed}
              description={task.description}
              equipment={task.equipment}
              imageUrl={task.imageUrl}
              name={task.name}
              quantities={getQuantities(task)}
              videoUrl={task.videoUrl}
            />
          ))}
        </Carousel>
      );
    }
    return <noscript />;
  }

  render() {
    const { tasks } = this.props;
    const { currentIndex } = this.state;
    return (
      <Panel id="scene-task" className="flex flex-column">
        <div className="f4 pa3 tc bg-primary white w-100">
          {tasks.length > 0 && tasks[currentIndex].name}
        </div>
        <CarouselDots
          length={tasks.length}
          currentSlide={currentIndex}
        />
        {this.renderTasks()}
        <CarouselArrow
          direction="left"
          hidden={currentIndex === 0}
          onClick={this.handleChangeSlide(currentIndex - 1)}
        />
        <CarouselArrow
          direction="right"
          hidden={currentIndex === tasks.length - 1 || tasks.length === 0}
          onClick={this.handleChangeSlide(currentIndex + 1)}
        />
      </Panel>
    );
  }
}

export default compose(
  graphql(GET_TASKS_FOR_DATE, {
    props: ({ data: { exercises } }) => ({
      tasks: exercises,
    }),
    options: ({ match: { params: { selectedDate } } }) => ({
      variables: {
        startDate: selectedDate,
        endDate: selectedDate,
      },
    }),
  }),
)(Task);
